module.exports = __webpack_public_path__ + "img/potassium.41efb5b3.png";